import React from "react";
import { Menu } from "lucide-react";

import { Dispatcher, Constants } from "../../../flux";

class NavbarToggle extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR
    });
  }

  render() {
    return (
      <nav className="nav">
        <button
          type="button"
          onClick={this.handleClick}
          className="nav-link nav-link-icon toggle-sidebar smartfarm-header-toggle d-sm-inline d-md-inline d-lg-none text-center"
          aria-label="Open navigation menu"
        >
          <Menu className="smartfarm-header-toggle-icon" aria-hidden="true" />
        </button>
      </nav>
    )
  }
}

export default NavbarToggle;
